// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"1d5689ed","140":"705fafb7","164":"58c16191","212":"c07f247a","316":"825f7510","388":"2311633d","536":"9bb04daf","552":"e1eadc1b","964":"c823df36","992":"825f7510"}[chunkId] + ".chunk.css";
};